import { useEffect, useState } from 'react';

/**
 * True once a card's entry animation has played. A re-rank makes React move
 * sibling DOM nodes, and a moved node restarts its CSS animations, so cards
 * that merely shifted would fade and tint again; `.is-settled` turns the
 * entry animation off after its 1.5 s run.
 */
export default function useEntrySettled(ms = 1600) {
  const [settled, setSettled] = useState(false);
  useEffect(() => {
    const t = setTimeout(() => setSettled(true), ms);
    return () => clearTimeout(t);
  }, [ms]);
  return settled ? 'is-settled' : '';
}
